import { API_BASE_URL } from './api';
import { authService } from './authService';
import type { CreateCommunityDiveSiteRequest, DiveSite, UpdateCommunityDiveSiteRequest } from '../types/DiveSite';

class CommunityDiveSiteService {
  async getCommunityDiveSites(): Promise<DiveSite[]> {
    const response = await fetch(`${API_BASE_URL}/divesites`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to fetch community dive sites: ${response.status} ${errorText}`);
    }

    return await response.json();
  }

  async createCommunityDiveSite(request: CreateCommunityDiveSiteRequest): Promise<DiveSite> {
    const response = await fetch(`${API_BASE_URL}/divesites`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...authService.getAuthHeaders(),
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const payload = await response.json().catch(() => null);
      throw new Error(payload?.error || 'Failed to create community dive site');
    }

    return await response.json();
  }

  async updateCommunityDiveSite(request: UpdateCommunityDiveSiteRequest): Promise<DiveSite> {
    const response = await fetch(`${API_BASE_URL}/divesites/${request.siteId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...authService.getAuthHeaders(),
      },
      body: JSON.stringify({
        name: request.name,
        region: request.region,
        country: request.country,
        latitude: request.latitude,
        longitude: request.longitude,
        matchRadiusKm: request.matchRadiusKm,
        siteType: request.siteType,
        difficulty: request.difficulty,
        summary: request.summary,
        highlights: request.highlights,
        tags: request.tags,
        aliases: request.aliases,
      }),
    });

    if (!response.ok) {
      const payload = await response.json().catch(() => null);
      throw new Error(payload?.error || 'Failed to update community dive site');
    }

    return await response.json();
  }
}

export const communityDiveSiteService = new CommunityDiveSiteService();